import { GET_VISIBLE_UNITS } from '@/graphql/querys/getVisibleUnits';
import { useSuspenseQuery } from '@apollo/client';

export const useSuspenseVisibleUnits = (userId?: number) => {
  const { data } = useSuspenseQuery(GET_VISIBLE_UNITS, {
    variables: { input: userId ? { id: userId } : null },
  });

  return data.user.preferences.visibleUnits;
};
